export const TelephonyWidgetTestIds = {
  STATUS_OPTION: 'telephony.status-option',
  WIDGET: 'telephony.widget-button',
  SETTINGS: 'telephony.settings-button',
  CLOSE: 'telephony.close-button',
};
